import React, { useState } from 'react';
import CalmiCharacter from '../pet/components/CalmiCharacter';
import { EMOTIONS, ONBOARDING_TAGS, CALMI_INTRO } from '../../shared/constants';
import { Button } from '../../shared/components';

const OnboardingScreen: React.FC<{ onNext: (emotion: string) => void }> = ({ onNext }) => {
  const [selectedEmotion, setSelectedEmotion] = useState('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-4 sm:p-6 md:p-8 flex flex-col items-center justify-center bg-pattern">
      <div className="w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl">
        {/* Título */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-slate-800 text-center mb-2">
          Conoce a Calmi 🌟
        </h1>
        <p className="text-sm sm:text-base md:text-lg text-slate-600 text-center mb-6">
          Tu compañero virtual que te escucha y te acompaña siempre.
        </p>

        {/* Calmi Character */}
        <div className="flex justify-center mb-6">
          <div className="animate-subtle-float">
            <CalmiCharacter size="large" />
          </div>
        </div>

        {/* Speech Bubble */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 shadow-lg mb-6 relative border border-slate-200">
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rotate-45 border-l border-t border-slate-200"></div>
          <p className="text-slate-700 text-center font-medium leading-relaxed">
            {CALMI_INTRO}
          </p>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {ONBOARDING_TAGS.map((tag, index) => (
            <span
              key={tag}
              className="px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 text-slate-700 rounded-full text-sm font-medium border border-blue-200 animate-subtle-float"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Emotion Selection */}
        <div className="mb-6">
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-slate-800 text-center mb-4">
            ¿Cómo te sientes hoy?
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            {EMOTIONS.map((emotion) => (
              <button
                key={emotion.id}
                onClick={() => {
                  setSelectedEmotion(emotion.id);
                  onNext(emotion.id);
                }}
                className={`p-3 sm:p-4 rounded-2xl border-2 transition-all btn-interactive ${
                  selectedEmotion === emotion.id
                    ? 'border-blue-400 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-md'
                    : 'border-slate-200 bg-white/80 backdrop-blur-sm hover:border-blue-300 hover:shadow-sm'
                }`}
              >
                <div className="text-2xl sm:text-3xl mb-1 animate-subtle-float">{emotion.emoji}</div>
                <div className="text-xs sm:text-sm text-slate-700 font-medium">{emotion.label}</div>
              </button>
            ))}
          </div>
        </div>

        {/* No sé cómo me siento */}
        <Button
          variant="secondary"
          fullWidth
          onClick={() => onNext('unknown')}
          className="flex items-center justify-center gap-2 btn-interactive bg-white/80 backdrop-blur-sm border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all"
        >
          <span className="text-lg sm:text-xl animate-subtle-float">☁️</span>
          No sé cómo me siento
        </Button>
      </div>
    </div>
  );
};

export default OnboardingScreen;
